import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { StoreCorporatePage, MapPinEnum } from '@desquared/wave-components-library';
import GOOGLE_API_KEY from '@/utils/googleAPIKey';
import { useTranslations } from 'next-intl';
import styles from './StoresPage.module.css';
import { useRouter } from 'next/router';

export default function StorePageSection(props) {
  const t = useTranslations('common.corporate.stores');
  const router = useRouter();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const setCards = data => {
    let list = [];
    data.forEach(el => {
      if (props.stores.data[0].content.locations[selectedIndex] === el.location || selectedIndex === 0) {
        let tempCard = {
          image: el.image?.url ?? undefined,
          storeName: el.store_name,
          openHours: el.open_hours,
          hasDelivery: el.hasdelivery,
          hasTakeaway: el.hastakeaway,
          description: '',
          buttonText: el.button_text,
          redirectionLink: el.redirection_link,
          redirectionAddress: el.redirection_address,
          address: el.address,
          phone: el.phone,
        };
        list.push(tempCard);
      }
    });
    return list;
  };
  const setStigmas = data => {
    let list = [];
    data.forEach(el => {
      if (props.stores.data[0].content.locations[selectedIndex] === el.location || selectedIndex === 0) {
        let tempCard = {
          postal: undefined,
          lat: Number(el.latitude),
          lng: Number(el.longtitude),
          pin: MapPinEnum.Wave,
        };
        list.push(tempCard);
      }
    });
    return list;
  };
  useEffect(() => {
    setStigmas(props.stores.data[0].content.stores);
    setCards(props.stores.data[0].content.stores);
  }, selectedIndex);

  return (
    <div className={cn(styles.storesLayout)}>
      <StoreCorporatePage
        title={props.stores.data[0].content.title}
        stigmas={setStigmas(props.stores.data[0].content.stores)}
        cards={setCards(props.stores.data[0].content.stores)}
        options={props.stores.data[0].content.locations}
        selectedIndex={selectedIndex}
        setIndex={setSelectedIndex}
        googleApiKey={GOOGLE_API_KEY}
        logo={props.responsiveLogo}
        phoneWording={t('phone_wording')}
        addressWording={t('address_wording')}
        mapTilesLocale={router.locale}
      />
    </div>
  );
}
